import { Screen } from 'constants/tracking/screens'

type FirstTimeListerEducationPageLeaveEventArgs = {
  pageNumber: number
  goingToPageNumber: number | null
  timeSpentOnPageMs: number
  initialPageScrollDepth: number
  pageScrollDepth: number
}

type FirstTimeListerEducationPageLeaveEventExtra = {
  page_number: number
  going_to_page_number: number | null
  time_spent_on_page_ms: number
  initial_page_scroll_depth: number
  page_scroll_depth: number
  screen: Screen
}

export const firstTimeListerEducationPageLeaveEvent = (
  args: FirstTimeListerEducationPageLeaveEventArgs,
) => {
  const extra: FirstTimeListerEducationPageLeaveEventExtra = {
    page_number: args.pageNumber,
    going_to_page_number: args.goingToPageNumber,
    time_spent_on_page_ms: args.timeSpentOnPageMs,
    initial_page_scroll_depth: args.initialPageScrollDepth,
    page_scroll_depth: args.pageScrollDepth,
    screen: Screen.FirstTimeListerEducation,
  }

  return {
    event: 'user.first_time_lister_education_page_leave',
    extra,
  }
}
